"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.9999 16.8125C25.6304 16.8125 26.2466 16.6256 26.7708 16.2753C27.295 15.9251 27.7036 15.4272 27.9448 14.8448C28.1861 14.2624 28.2492 13.6215 28.1262 13.0032C28.0032 12.3848 27.6996 11.8169 27.2538 11.3711C26.8081 10.9253 26.2401 10.6217 25.6218 10.4987C25.0035 10.3758 24.3626 10.4389 23.7801 10.6801C23.1977 10.9214 22.6999 11.3299 22.3496 11.8541C21.9994 12.3783 21.8124 12.9946 21.8124 13.625C21.8124 14.4704 22.1483 15.2811 22.746 15.8789C23.3438 16.4767 24.1546 16.8125 24.9999 16.8125Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.9999 28.1875C25.6304 28.1875 26.2466 28.0006 26.7708 27.6503C27.295 27.3001 27.7036 26.8022 27.9448 26.2198C28.1861 25.6374 28.2492 24.9965 28.1262 24.3782C28.0032 23.7598 27.6996 23.1919 27.2538 22.7461C26.8081 22.3003 26.2401 21.9967 25.6218 21.8737C25.0035 21.7508 24.3626 21.8139 23.7801 22.0551C23.1977 22.2964 22.6999 22.7049 22.3496 23.2291C21.9994 23.7533 21.8124 24.3696 21.8124 25C21.8179 25.8437 22.1555 26.6513 22.7521 27.2479C23.3487 27.8445 24.1563 28.182 24.9999 28.1875Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.9999 39.5833C25.6313 39.5833 26.2483 39.3958 26.773 39.0447C27.2976 38.6935 27.7061 38.1944 27.9468 37.6108C28.1874 37.0271 28.2493 36.3852 28.1246 35.7663C27.9999 35.1474 27.6942 34.5795 27.2464 34.1346C26.7985 33.6896 26.2286 33.3877 25.6089 33.2671C24.9892 33.1464 24.3477 33.2125 23.7656 33.457C23.1836 33.7014 22.6872 34.1132 22.3395 34.6401C21.9917 35.1671 21.8083 35.7854 21.8124 36.4167C21.8179 37.2584 22.1562 38.0638 22.7534 38.6571C23.3506 39.2504 24.1582 39.5834 24.9999 39.5833Z",
    fill: fill
  }));
};

exports["default"] = _default;